<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <div
        style="text-align:center; font-size: 20px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
      >
        {{ $t("user_guest.title") }}
      </div>
    </div>
    <form class="form-horizontal">
      <div class="box-body">
        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t("user_guest.first_name")
          }}</label>
          <div class="col-sm-6">
            <input
              type="text"
              v-model="user_guest.first_name"
              class="form-control"
              @input="validate_fistName"
              :placeholder="$t('user_guest.first_name')"
            />
            <span
              v-if="userguestFirstNameStatus == false"
              class="help is-danger"
            >
              <font color="red">{{ $t(error_msg.userguestFirstNameSmg) }}</font>
            </span>
          </div>
        </div>
        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t("user_guest.last_name")
          }}</label>
          <div class="col-sm-6">
            <input
              type="text"
              @input="validate_lastName"
              v-model="user_guest.last_name"
              class="form-control"
              :placeholder="$t('user_guest.last_name')"
            />
            <span
              v-if="userguestLastNameStatus == false"
              class="help is-danger"
            >
              <font color="red">{{ $t(error_msg.userguestLastNameSmg) }}</font>
            </span>
          </div>
        </div>
        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t("user_guest.phone")
          }}</label>
          <div class="col-sm-6">
            <input
              type="text"
              v-model="user_guest.phone"
              @input="validate_phone"
              maxlength="10"
              class="form-control"
              :placeholder="$t('user_guest.phone')"
            />
            <span v-if="userguestPhoneStatus == false" class="help is-danger">
              <font color="red">{{ $t(error_msg.userguestPhoneSmg) }}</font>
            </span>
          </div>
        </div>
        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t("user_guest.identification")
          }}</label>
          <div class="col-sm-6">
            <input
              type="text"
              class="form-control"
              v-model="user_guest.identification"
              :placeholder="$t('user_guest.identification')"
            />
          </div>
        </div>
        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t("user_guest.checkin")
          }}</label>
          <div class="col-sm-2">
            <date-picker
              class="form-control"
              v-model="user_guest.checkin"
              :config="options"
              :placeholder="$t('DD/MM/YYYY')"
            ></date-picker>
          </div>
          <div class="col-sm-2">
            <date-picker
              style="width: 100px"
              class="form-control"
              :placeholder="$t('HH/HH')"
              v-model="user_guest.checkin_time"
              :config="options_time"
            ></date-picker>
          </div>
          <span>{{ $t("user_guest.mess_checkin_out") }}</span>
        </div>

        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t("user_guest.checkout")
          }}</label>
          <div class="col-sm-2">
            <date-picker
              class="form-control"
              v-model="user_guest.checkout"
              :config="options"
              :placeholder="$t('DD/MM/YYYY')"
            ></date-picker>
          </div>
          <div class="col-sm-2">
            <date-picker
              class="form-control"
              style="width: 100px"
              v-model="user_guest.checkout_time"
              :config="options_time"
              :placeholder="$t('HH/MM')"
            ></date-picker>
          </div>
          <span>{{ $t("user_guest.mess_checkin_out") }}</span>
        </div>
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-danger"
          @click="doCancel"
          style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
        >
          <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
          {{ $t("common.back") }}
        </button>

        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          style="margin-right: 5px;"
          @click="onSave"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{ $t("common.save") }}
        </button>
      </div>
    </form>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import datePicker from "vue-bootstrap-datetimepicker";
import LTECoreAlert from "@/components/LTESnackBar.vue";
// import utils from '@/lib/utils'

export default {
  name: "UserGuestAdd",
  data() {
    return {
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      options_time: {
        format: "HH:mm",
        useCurrent: false
      },

      isLoading: false,
      user_guest: {
        first_name: null,
        last_name: null,
        phone: null,
        identification: null,
        checkin_time: "",
        checkout_time: "",
        checkin: "",
        checkout: ""
      },
      error_msg: {
        userguestFirstNameSmg: "",
        userguestLastNameSmg: "",
        userguestPhoneSmg: "",
        userguestIdentificationSmg: "",
        userguestDateTimeSmg: ""
      },
      userguestFirstNameStatus: true,
      userguestLastNameStatus: true,
      userguestPhoneStatus: true,
      userguestDateTimeStatus: true
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_USER_GUEST_DETAIL_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "UPDATE_USER_GUEST",
      "ADD_USER_GUEST",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_USER_GUEST_DETAIL",
      "ON_SHOW_TOAST"
    ]),
    onSave() {
      if (this.checkForm()) {
        this.isLoading = true;
        let id = parseInt(this.$route.params.id);
        let data = {
          first_name: this.user_guest.first_name,
          last_name: this.user_guest.last_name,
          phone: this.user_guest.phone,
          identification: this.user_guest.identification,
          checkin: this.user_guest.checkin !== null ? this.user_guest.checkin : null,
          checkout: this.user_guest.checkout !== null ? this.user_guest.checkout : null,
          checkin_time: this.user_guest.checkin_time !== null ? this.user_guest.checkin_time : null,
          checkout_time: this.user_guest.checkout_time !== null ? this.user_guest.checkout_time : null
        };
        this.isLoading = true;
        if (id != 0) {
          this.UPDATE_USER_GUEST({ id: id, ...data })
            .then(
              function() {
                this.SUCCESS_TOAST();
                this.$router.push({
                  name: "UserGuestList"
                });
                this.isLoading = false;
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        } else {
          this.ADD_USER_GUEST(data)
            .then(
              function() {
                this.isLoading = false;
                this.SUCCESS_TOAST();
                this.$router.push({
                  name: "UserGuestList"
                });
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        }
      }
    },
    validate_fistName: function() {
      this.error_msg.userguestFirstNameSmg = "";
      this.userguestFirstNameStatus = true;
      if (
        this.user_guest.first_name == null ||
        this.user_guest.first_name == ""
      ) {
        this.error_msg.userguestFirstNameSmg =
          "user_guest.error_msg[0].required";
        this.userguestFirstNameStatus = false;
      }
      return this.userguestFirstNameStatus;
    },
    validate_lastName: function() {
      this.error_msg.userguestLastNameSmg = "";
      this.userguestLastNameSmg = true;
      if (
        this.user_guest.last_name == null ||
        this.user_guest.last_name == ""
      ) {
        this.error_msg.userguestLastNameSmg =
          "user_guest.error_msg[0].required";
        this.userguestLastNameStatus = false;
      }
      return this.userguestLastNameStatus;
    },
    validate_phone: function() {
      let regex_phone = /^[0-9]+$/;
      this.error_msg.userguestPhoneSmg = "";
      this.userguestPhoneSmg = true;
      if (this.user_guest.phone == null || this.user_guest.phone == "") {
        this.error_msg.userguestPhoneSmg = "user_guest.error_msg[0].required";
        this.userguestPhoneStatus = false;
      } else if (!this.user_guest.phone.match(regex_phone)) {
        this.error_msg.userguestPhoneSmg =
          "user_guest.error_msg[1].number_incorrect_format";
        this.userguestPhoneStatus = false;
      }
      return this.userguestPhoneStatus;
    },
    checkForm() {
      let check_fistName = this.validate_fistName();
      let check_lastName = this.validate_lastName();
      let check_phone = this.validate_phone();
      if (check_fistName && check_lastName && check_phone) {
        return true;
      } else {
        return false;
      }
    },
    doCancel() {
      this.$router.push({
        name: "UserGuestList"
      });
    }
  },
  watch: {
    GET_USER_GUEST_DETAIL_DATA: function() {
      this.user_guest.first_name = this.GET_USER_GUEST_DETAIL_DATA.first_name;
      this.user_guest.last_name = this.GET_USER_GUEST_DETAIL_DATA.last_name;
      this.user_guest.phone = this.GET_USER_GUEST_DETAIL_DATA.phone;
      this.user_guest.identification = this.GET_USER_GUEST_DETAIL_DATA.identification;
      this.user_guest.checkin = utils.formatSqlDate(this.GET_USER_GUEST_DETAIL_DATA.checkin, "YYYY-MM-DD HH:mm:ss.SSSZZZ", "DD/MM/YYYY HH:mm");
      this.user_guest.checkout = utils.formatSqlDate(this.GET_USER_GUEST_DETAIL_DATA.checkout, "YYYY-MM-DD HH:mm:ss.SSSZZZ", "DD/MM/YYYY HH:mm");
      this.user_guest.checkin_time = utils.formatSqlDate(this.GET_USER_GUEST_DETAIL_DATA.checkin, "YYYY-MM-DD HH:mm:ss.SSSZZZ", "HH:mm");
      this.user_guest.checkout_time = utils.formatSqlDate(this.GET_USER_GUEST_DETAIL_DATA.checkout, "YYYY-MM-DD HH:mm:ss.SSSZZZ", "HH:mm");
    }
  },
  mounted() {
    let id = this.$route.params.id;
    if (id !== 0) {
      this.GET_USER_GUEST_DETAIL({ id: id });
    }
  },
  components: {
    "date-picker": datePicker,
    loading: Loading,
    "lte-core-alert": LTECoreAlert
  }
};
</script>
<style scoped>
.form-group.required .control-label:after {
  color: #d00;
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
}
</style>



// WEBPACK FOOTER //
// src/views/UserGuest/UserGuestAdd.vue